var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgShareOrRaud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 9000 9000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9528,0,0,0.98047,202.051,231.457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4767,228.245L4767,2579.76M4756.51,5547.89C4756.51,6289.4 4770.15,6982.98 4770.15,7724.49M4772.45,231.732L8773.63,4012.21",
    style: {
      fill: "none",
      stroke: "rgb(230,0,0)",
      strokeWidth: 862
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.94999,0.0027,0.00262,0.97797,195.368,237.845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8784.49,4009.22L4771.62,7744.13",
    style: {
      fill: "none",
      stroke: "rgb(230,0,0)",
      strokeWidth: "862.01px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9528,0,0,0.98047,202.051,231.457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4750,2579C3599.74,2593.36 465.899,2576.29 248,8218",
    style: {
      fill: "none",
      stroke: "rgb(230,0,0)",
      strokeWidth: 862
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9527,0.01428,-0.01388,0.98037,385.58,127.685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4642.92,5550.2C4421.86,5500.53 1868.78,5108.28 194.287,8308.65",
    style: {
      fill: "none",
      stroke: "rgb(230,0,0)",
      strokeWidth: "861.65px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareOrRaud);
export default __webpack_public_path__ + "static/media/share_or_raud.9ba63c391b3290118dc4fea6524ca26b.svg";
export { ForwardRef as ReactComponent };